import React, {useMemo} from 'react';
import styles from './ProjectPhasesBar.module.scss';
import DeliverablesBar from './ProjectPhasesBar/DeliverablesBar.jsx';
import PhaseDatesEditor from './ProjectPhasesBar/PhaseDatesEditor.jsx';

const ProjectPhaseBar = ({phase, prevPhase, phasesCount, isActive, handlePhaseClick, context}) => {
  const inTransition = useMemo(() => {
    const transition = phase.incoming?.[0] || {};
    if (Object.keys(transition.rule_set || {}).length > 0 || phase.is_terminal_phase) {
      const rule = phase.incoming_rules.find(t => t.id === transition.id) || {};
      return {...transition, ...rule}
    }
    return null;
  }, [phase.incoming]);

  const isLastPhase = useMemo(() => phase.current && phase.idx === phasesCount - 1, [phase.idx]);

  const phaseClass = phase.completed || isLastPhase ? styles.full : phase.current ? styles.partial : styles.defaultColor;
  const prevPhaseClass = prevPhase?.completed || isLastPhase ? styles.full : prevPhase?.current ? styles.partial : styles.defaultColor;

  const gate = inTransition &&
    <div className={`${styles.diamond} ${prevPhaseClass} ${styles[`status-${inTransition.status}`]}`}>
      <span>{inTransition.name}</span>
    </div>;

  return (
    <div className={styles.phaseWrapper} style={phase.is_terminal_phase ? {flex: 0, margin: '9px 15px 0 0'}: {}}>
      <div className={styles.phaseContent}>
        {inTransition &&
          <>{gate}</>
        }

        {!phase.is_terminal_phase &&
          <>
            <div className={styles.arrowContainer} onClick={() => handlePhaseClick(phase)}>
              <div className={`${styles.arrowBackground} ${phaseClass} ${isActive && styles.active}`}>
                <div className={`${styles.phaseLabel} ${isActive ? styles.partial : styles.defaultColor}`}>{phase.name?.[I18n.locale]}</div>
                <div className={`${styles.arrowFill} ${phaseClass}`} style={{width: `${phase.completed ? 100 : phase.progress_percent}%`}}/>
              </div>

              {isActive && context === 'project_workspace' && (
                <div className={`${styles.activeArrowButton} ${phase.completed || isLastPhase ? styles.full : phase.current ? styles.partial : styles.defaultColor}`}/>
              )}

              <div className={styles.phaseDate}>
                {DT.dt(phase.start_date)}
              </div>
            </div>

            <div className={`${styles.rightTriangle} ${phaseClass} ${isActive && styles.active}`}/>
          </>
        }
      </div>
    </div>
  );
};

const ProjectPhasesBar = ({
  project_id,
  phases = [],
  setPhases,
  shownPhase,
  setShownPhase,
  onNextStep,
  canManageProjectPhases = false,
  isContractModuleEnabled,
  context = '',
}) => {
  const phasesCount = useMemo(() => phases.length, [phases]);

  const handlePhaseClick = (phase) => {
    setShownPhase(phase)
  };

  const handleNextClick = (id) => {
    if(confirm(I18n.t('next_phase_confirmation'))) {
      onNextStep(id)
    }
  };

  return (
    <>
      <div className={styles.phasesContainer}>
        {phases.map((phase, idx) => {
          const isActive = phase.id === shownPhase.id;
          const prevPhase = idx > 0 ? phases[idx - 1] : null;
          return <ProjectPhaseBar key={`phase-${phase.id}-${idx}`} {...{isActive, phasesCount, phase, prevPhase, handlePhaseClick, context}}/>
        })}

      </div>

      { context === 'project_workspace' && <>
        { canManageProjectPhases &&
          <PhaseDatesEditor {...{project_id, phases, setPhases, isContractModuleEnabled}}/>
        }

        <DeliverablesBar
          project_id={project_id}
          phaseId={shownPhase?.id}
          phases={phases}
          setPhases={setPhases}
          onNextStep={handleNextClick}
          canManageProjectPhases={canManageProjectPhases}
        />
      </>

      }
    </>
  );
};

export default ProjectPhasesBar;
